export const branchConfig = {
  branchId: "gwanggyo",
  identityDisabled: true, // 미정 TODO — 카카오 심사 완료 후 복원
  integrationsDisabled: true, // 미정 TODO — 외부 차트·결제선생 연동 준비 중

  // 미들웨어 설정 (#878 — middleware.js 에 박혀 있던 옵션).
  // 쿠키 domain 은 한 번 심기면 리버트해도 브라우저에 남는다 — 값을 그대로 옮겼다.
  middleware: {
    localePrefixes: ["en"],
  },

  // 홈 빠른상담 설정 (#874 — homeClient 에 박혀 있던 값).
  homeQuickConsult: {
    enableIdentity: false, // 미정 TODO — 카카오 심사 완료 후 인증 복원
    // 빠른상담 전송 경로 — 현재 코드에서 읽었다 (#874).
    submitVia: null, // 미정 TODO — 외부 차트 전송 없이 접수
  },
  // 홈 구조화 데이터의 기관명 (#874).
  homeJsonLd: { orgNameKo: "끗 한의원 광교점", orgNameEn: "Gwanggyo KKEUT Clinic" },

  // 비급여 안내의 병원명 표기 (#872 — 페이지에 박혀 있던 값).
  // 지금은 읽는 곳이 없다 (#892). 공유본이 6월에 상단 노출을 지웠다 —
  // 다시 노출하기로 하면 쓸 값이라 남겨 둔다.
  // branchTitle·titleTail 과 섞여 있어 유도할 수 없어 그대로 옮겼다.
  uncoveredFeesHospital: {"ko":"광교 끗 한의원","en":"Gwanggyo KKEUT Korean Clinic","ja":"光教 KKEUT韓医院","zh":"光教 KKEUT韩医院"},

  // 푸터의 지점 표기 (#861 — 래퍼에 박혀 있던 값).
  branchTitle: {"ko":"광교 끗 한의원","en":"KKEUT Gwanggyo","ja":"KKEUT韓医院（光教）","zh":"KKEUT韩医院（光教）","th":"KKEUT กวางกโย"},
  // 홈 소셜 섹션 (#861). 기존 social 키와 쓰임이 달라 분리한다.
  socialShowcase: {
    overline: { ko: "끗 한의원 광교점" },
    youtube: "",
    instagram: "",
  },
  fallbackDomain: "https://www.kkeutclinic-gwanggyo.co.kr",
  // 외국어 홈 검색 제목 — 지역 + 분야 + 병원명. 한국어는 titleTail 그대로 (titleTail 은 다른 페이지 제목 끝에도 붙어서 따로 둔다).
  homeTitle: {
    en: "Gwanggyo Skin Clinic | KKEUT Korean Medicine Clinic",
    ja: "光教 肌管理・スキンクリニック | KKEUT韓医院",
    zh: "光教 皮肤管理诊所 | KKEUT韩医院",
    th: "คลินิกผิว กวางกโย | KKEUT Korean Medicine Clinic",
  },
  titleTail: {
    ko: "광교 끗 한의원",
    en: "Gwanggyo KKEUT Korean Clinic",
    ja: "光教 KKEUT韓医院",
    zh: "光教 KKEUT韩医院",
    th: "กวางกโย KKEUT Korean Clinic",
  },
  areaPrefix: { ko: "광교", en: "Gwanggyo", ja: "光教", zh: "光教" },
  naver: "", // 미정 TODO — 사이트 소유확인 코드
  google: "", // 미정 TODO — 사이트 소유확인 코드
  homeDesc: {
    ko: "인근 한의원. 광교 리프팅 · 제모 · 여드름 · 피부과 시술부터 다이어트/약침/부종 관리까지 한 번에 상담하세요.",
    en: "Korean medicine skin clinic in Gwanggyo. Lifting, laser/toning, hair removal, acne care, diet and pharmacopuncture — in Gwanggyo.",
    ja: "光教エリアの韓方×美容クリニック。リフティング、レーザー/トーニング、脱毛、ニキビケア、ダイエット、薬鍼まで一ヶ所でご相談いただけます。",
    zh: "位于光教的韩方+皮肤诊所。提升、激光/焕肤、脱毛、痘痘护理、减脂、药针，在光教一次完成。",
  },
  homeKeywords: {
    ko: ["광교 한의원","광교 한의원","광교 끗 한의원","광교 한의원","광교 피부과","광교 리프팅","광교 약침","광교 레이저토닝","광교 제모","광교 여드름","광교 스킨부스터","광교 다이어트 한의원","광교 한의원"],
    en: ["KKEUT Clinic Gwanggyo","Gwanggyo clinic","Korean medicine","lifting","acne care","laser toning","hair removal","diet program","pharmacopuncture"],
    ja: ["光教 韓医院","光教 クリニック","リフティング","ニキビケア","レーザートーニング","医療脱毛","ダイエット"],
    zh: ["光教 韩医院","光教 诊所","皮肤管理","提升","痘痘护理","激光焕肤","脱毛","减肥诊所"],
  },
  policyHospitalName: {
    ko: "광교 끗 한의원",
    en: "Gwanggyo",
    ja: "光教",
    zh: "光教",
  },

  // 화면별 SEO 문구 — 단일앱에서는 파일이 하나뿐이라 지점 데이터는
  // 전부 설정으로 와야 한다 (#846).
  seo: {
    networkLayout: {
      sameAs: [
      ],
      i18n: {
      title: {
        ko: "광교 끗 한의원, 한 끗 차이의 아름다움",
        en: "Gwanggyo KKEUT Clinic — The Beauty in Detail",
        ja: "光教 KKEUT 韓医院 — ひとすじ違いの美しさ",
        zh: "光教 KKEUT韩医院 — 一线之差的美",
      },
      desc: {
        ko: "전국 피부·다이어트·리프팅 전문 한의원 네트워크",
        en: "Nationwide Korean medicine clinic network for skin, diet, and lifting",
        ja: "全国の皮膚・ダイエット・リフティング専門 韓方クリニック ネットワーク",
        zh: "全国皮肤/减肥/提升 专业韩医诊所网络",
      },
      ogLocale: { ko: "ko_KR", en: "en_US", ja: "ja_JP", zh: "zh_CN" },
    },
    },
    beforeDetail: {
  defaultKeywords: {
    ko: [
      "광교 전후사진",
      "광교 시술 전후",
      "광교 피부과 전후사진",
      "광교 리프팅 전후",
      "광교 여드름 치료 전후",
      "광교 제모 전후",
      "광교 필러 전후",
      "광교 보톡스 전후",
      "광교 피부과",
      "광교 끗 한의원 전후사진",
    ],
    en: [
      "gwanggyo before and after",
      "gwanggyo skin clinic photos",
      "gwanggyo lifting before after",
      "gwanggyo acne treatment before after",
      "gwanggyo filler before after",
      "korean clinic before after gwanggyo",
    ],
    ja: [
      "光教 ビフォーアフター",
      "光教 美容クリニック 症例写真",
      "光教 リフティング ビフォーアフター",
      "光教 ニキビ治療 症例",
      "韓国 光教 施術 前後",
    ],
    zh: [
      "光教 术前术后",
      "光教 美容 术前术后 照片",
      "光教 提拉 前后对比",
      "光教 痘痘治疗 前后对比",
      "韩国光教 医美 案例",
    ],
  },
    },
    mainLayout: {
  branchId: "gwanggyo",
  i18n: {
    title: {
      ko: "광교 끗 한의원, 한 끗 차이의 아름다움",
      en: "Gwanggyo KKEUT Korean Medicine Clinic, Beauty in One Fine Difference",
      ja: "光教 KKEUT韓医院、ひとすじ違いの美しさ",
      zh: "光教 KKEUT韩医院，一线之差的美",
    },
    desc: {
      ko: "광교 한의원. 광교 리프팅, 광교 약침, 광교 레이저토닝, 광교 제모, 광교 여드름, 광교 스킨부스터까지 한 번에 상담하세요.",
      en: "Korean medicine & dermatology clinic in Gwanggyo. Lifting, acupuncture, laser toning, hair removal, acne care, skin boosters — in Gwanggyo.",
      ja: "光教エリアの韓方×美容クリニック。リフティング、薬鍼、レーザートーニング、脱毛、ニキビケア、スキンブースターなどに対応します。",
      zh: "位于光教的韩方+皮肤诊所。提升、药针、激光焕肤、脱毛、痘痘护理、皮肤补剂等项目，一站式完成。",
    },
    keywords: {
      ko: ["광교 한의원","광교 한의원","광교 끗 한의원","광교 한의원","광교 피부과","광교 리프팅","광교 약침","광교 레이저토닝","광교 제모","광교 여드름","광교 스킨부스터","광교 다이어트 한의원","광교 한의원"],
      en: ["KKEUT Clinic Gwanggyo","Gwanggyo clinic","Korean medicine","lifting","acupuncture","laser toning","hair removal","acne care","skin booster","diet program"],
      ja: ["光教 韓医院","光教 クリニック","リフティング","薬鍼","レーザートーニング","脱毛","ニキビケア","スキンブースター"],
      zh: ["光教 韩医院","光教 诊所","皮肤管理","提升","激光嫩肤","脱毛","痘痘护理","皮肤补剂"],
    },
    ogLocale: { ko: "ko_KR", en: "en_US", ja: "ja_JP", zh: "zh_CN" },
  },
  areaPrefix: { ko: "광교", en: "Gwanggyo", ja: "光教", zh: "光教" },
  orgName: {
    ko: "광교 끗 한의원",
    en: "Gwanggyo KKEUT Korean Clinic",
  },
  sameAs: [
    "https://www.kkeutclinic-gwanggyo.co.kr",
  ],
  naverFallback: "", // 미정 TODO — 사이트 소유확인 코드
  googleFallback: "", // 미정 TODO — 사이트 소유확인 코드
    },
    skinNoteDetail: {
  baseTitle: {
    ko: "시술 노트 | 광교 끗 한의원",
    en: "Procedure Notes | Gwanggyo KKEUT Korean Clinic",
    ja: "施術ノート | 光教 KKEUT韓医院",
    zh: "项目笔记 | 光教 KKEUT韩医院",
  },
  baseDesc: {
    ko: "시술 원리, 전후 관리, 케이스 인사이트를 정리한 광교 끗 한의원 시술 노트 상세 페이지입니다.",
    en: "Gwanggyo KKEUT Clinic procedure note — principles, aftercare, and case insights.",
    ja: "光教KKEUT韓医院の施術ノート詳細ページです。施術原理、アフターケア、症例のポイントをまとめました。",
    zh: "光教 KKEUT韩医院项目笔记详情页：原理、术后护理与案例要点。",
  },
  defaultKeywords: {
    ko: [
      "광교 시술 노트",
      "광교 끗 한의원",
      "광교 피부 시술",
      "레이저",
      "리프팅",
      "토닝",
      "제모",
      "여드름",
      "흉터",
      "색소",
    ],
    en: [
      "Gwanggyo procedure notes",
      "Gwanggyo dermatology",
      "laser",
      "lifting",
      "toning",
      "hair removal",
      "acne",
      "scar",
      "pigmentation",
    ],
    ja: [
      "光教 施術ノート",
      "光教 皮膚",
      "レーザー",
      "リフティング",
      "トーニング",
      "脱毛",
      "ニキビ",
      "瘢痕",
      "色素",
    ],
    zh: [
      "光教 项目笔记",
      "光教 皮肤",
      "激光",
      "提升",
      "嫩肤",
      "脱毛",
      "痤疮",
      "疤痕",
      "色素",
    ],
  },
    },
    clinicPriceDetail: {
  baseDesc: {
    ko: "광교 끗 한의원의 시술 상세 페이지입니다. 시술 설명, 가격, 시술 후 주의사항을 확인하세요.",
    en: "Detailed procedure page for KKEUT Clinic Gwanggyo. Check description, pricing and aftercare.",
    ja: "KKEUT韓医院 光教院の施術詳細ページです。施術内容・価格・注意事項をご確認ください。",
    zh: "光教 KKEUT韩医院的项目详情页。可查看项目内容、价格及术后注意事项。",
  },
  defaultKeywords: {
    ko: ["광교 끗 한의원", "광교 피부과 시술", "광교 레이저", "광교 리프팅", "광교 여드름", "광교 제모", "광교 피부과", "광교 한의원"],
    en: ["gwanggyo treatment", "gwanggyo skin clinic", "gwanggyo laser clinic", "korean skin clinic gwanggyo"],
    ja: ["光教 施術", "光教 美容クリニック", "光教 レーザー", "韓国 美容 クリニック 光教"],
    zh: ["光教 皮肤科", "光教 美容诊所", "光教 激光 项目", "韩国 光教 韩医院"],
  },
  areaServed: "Gwanggyo, Korea",
    },
    uncoveredFees: {
  keywords: {
  ko: ["비급여 진료비용", "비급여 안내", "시술 비용", "끗 한의원 비용"],
  en: ["non-covered fees", "korean clinic price", "kkeut clinic fee guide"],
  ja: ["保険外診療費", "施術費用", "韓医院 費用"],
  zh: ["非医保费用", "诊疗费用", "韩医院价格"]
},
    },
    reserve: {
  pageLabel: {
  ko: "온라인 예약",
  en: "Online Reservation",
  ja: "オンライン予約",
  zh: "在线预约"
},
  desc: {
  ko: "광교 끗 한의원 간편 온라인 예약. 피부, 다이어트, 리프팅 시술 예약하기.",
  en: "Easy online booking for KKEUT Clinic Gwanggyo. Skin, Diet, Lifting.",
  ja: "光教のKKEUT韓医院、簡単オンライン予約。皮膚・ダイエット・リフティング。",
  zh: "光教 KKEUT韩医院便捷在线预约。皮肤/减肥/提升项目。"
},
  robots: { index: false, follow: false },
    },
    doctors: {
  fallbackRegion: "광교",
  keywords: [
    "광교 한의원 원장 소개",
    "광교 한의원",
    "광교 피부과 시술",
    "광교 레이저토닝",
    "광교 리프팅",
    "광교 제모",
    "광교 피부미용",
    "광교 보톡스",
    "광교 필러",
    "광교 여드름",
    "광교 점·잡티 제거",
    "광교 실리프팅",
    "광교 비만/체형",
    "광교 지방분해주사",
    "끗 한의원 의료진",
    "광교 스킨부스터",
  ],
    },
    rssNote: {
  keywords: {
    ko: [
      "광교 끗 한의원",
      "광교 피부과",
      "광교 레이저 시술",
      "광교 제모 클리닉",
      "광교 리프팅",
      "광교 다이어트 한의원",
      "광교 여드름 한의원",
      "광교 피부과",
      "광교 한의원",
    ],
    en: [
      "Gwanggyo skin clinic",
      "Gwanggyo KKEUT Clinic",
      "Gwanggyo laser treatment",
      "Gwanggyo lifting clinic",
      "Korean medicine dermatology",
      "Gwanggyo tattoo removal",
    ],
    ja: [
      "光教 皮膚 クリニック",
      "光教 韓医院",
      "光教 レーザー 施術",
      "光教 リフティング",
      "韓方 ダイエット 光教",
    ],
    zh: [
      "光教 皮肤科",
      "光教 韩医院",
      "光教 激光 美肤",
      "光教 提升 诊所",
    ],
  },
    },
    before: {
  baseDesc: {
    ko: "{{TAIL}}에서 실제 고객이 받은 리프팅, 여드름, 제모·바디 시술의 전후 사진을 확인해보세요. 광교 지역 증례를 중심으로 보여드립니다.",
    en: "See real lifting, acne, contouring and body Before & After cases from {{TAIL}} in Gwanggyo.",
    ja: "光教の{{TAIL}}で実際に施術を受けた方のビフォー＆アフター症例です。リフティング・ニキビ・痩身などを写真で確認できます。",
    zh: "在{{TAIL}}（光教）查看真实顾客的术前术后对比，包含提升、痘痘治疗、体形管理等案例。",
  },
  keywords: {
    ko: ["광교 전후사진","광교 시술 전후","광교 피부과 전후사진","광교 리프팅 전후","광교 여드름 치료 전후","광교 제모 전후","광교 필러 전후","광교 보톡스 전후","광교 피부과","광교 끗 한의원 전후사진"],
    en: ["gwanggyo before and after","gwanggyo skin clinic photos","gwanggyo lifting before after","gwanggyo acne treatment before after","gwanggyo filler before after","korean clinic before after gwanggyo"],
    ja: ["光教 ビフォーアフター","光教 美容クリニック 症例写真","光教 リフティング ビフォーアフター","光教 ニキビ治療 症例","韓国 光教 施術 前後"],
    zh: ["光教 术前术后","光教 美容 术前术后 照片","光教 提拉 前后对比","光教 痘痘治疗 前后对比","韩国光教 医美 案例"],
  },
    },
    blogNote: {
  baseDesc: {
    ko: "광교 끗 한의원 원장 블로그. 피부·리프팅·제모·여드름 시술 원리와 실제 케이스, 사후 관리 팁을 정리했습니다.",
    en: "KKEUT Clinic director's blog in Gwanggyo — treatment principles, real cases and aftercare tips.",
    ja: "光教にあるKKEUT韓医院 院長ブログ。施術の考え方、実例、アフターケアのポイントをまとめました。",
    zh: "光教 KKEUT韩医院 院长博客：项目原理、真实案例、术后护理重点。",
  },
  keywords: {
    ko: [
      "광교 피부과 블로그",
      "광교 시술 후기",
      "광교 레이저토닝",
      "광교 기미 색소 치료",
      "광교 여드름 치료",
      "광교 리프팅",
      "광교 제모",
      "광교 피부과",
      "광교 끗 한의원",
      "광교 피부과",
    ],
    en: [
      "gwanggyo skin clinic blog",
      "gwanggyo dermatology",
      "korean aesthetic treatments gwanggyo",
      "laser toning gwanggyo",
      "lifting in gwanggyo",
      "acne treatment gwanggyo",
    ],
    ja: [
      "光教 美容 クリニック ブログ",
      "光教 皮膚科 韓国 施術",
      "光教 レーザートーニング",
      "光教 リフティング 施術",
      "光教 ニキビ 治療",
    ],
    zh: [
      "光教 皮肤科 博客",
      "光教 美容医院 韩国",
      "光教 激光 美白",
      "光教 提拉 项目",
      "光教 痘痘 治疗",
    ],
  },
    },
    cart: {
      descArea: { ko: "광교", en: "Gwanggyo", ja: "光教", zh: "光教" },
      kwMap: {
  ko: [
    "광교 끗 한의원",
    "광교 피부과 예약",
    "광교 한의원 시술",
    "광교 장바구니",
    "광교 레이저 제모",
    "광교 여드름 치료",
    "광교 리프팅",
    "광교 피부과",
    "광교 시술 예약",
  ],
  en: [
    "gwanggyo clinic cart",
    "gwanggyo skin clinic",
    "gwanggyo laser booking",
    "gwanggyo hair removal",
    "gwanggyo acne treatment",
    "korean aesthetic clinic",
  ],
  ja: [
    "光教 クリニック 予約",
    "光教 美容",
    "光教 レーザー 施術",
    "光教 脱毛 予約",
    "韓国 美容 クリニック",
  ],
  zh: [
    "光教 韩医院",
    "光教 皮肤科",
    "光教 美容 项目 预约",
    "光教 激光 脱毛",
    "韩国 美容 诊所 光教",
  ],
},
  robots: { index: false, follow: false },
    },
    kkeut: {
  defaultDesc: {
    ko: "광교 일대에서 피부·다이어트·리프팅 중심의 맞춤 한방 진료를 제공합니다. 병원 철학, 진료 방향, 시설 정보를 확인해보세요.",
    en: "A Korean medicine clinic in Gwanggyo focused on skin, diet and lifting. Read about our philosophy, care approach and facilities.",
    ja: "光教エリアで、皮膚・ダイエット・リフティングに特化した韓方クリニックです。理念・診療方針・設備情報をご覧ください。",
    zh: "位于光教，专注皮肤、减肥与提升的韩医诊所。查看我们的理念、诊疗方向与设施信息。",
  },
  defaultKw: {
    ko: [
      "광교 피부과",
      "광교 피부과",
      "광교 미용의원",
      "광교 피부과 추천",
      "광교 여드름치료",
      "광교 제모",
      "광교 레이저제모",
      "광교 리프팅",
      "광교 보톡스",
      "광교 필러",
      "광교 기미잡티",
      "광교 스킨부스터",
      "광교 다이어트 한의원",
      "광교 한방 다이어트",
      "광교 피부과",
    ],
    en: [
      "gwanggyo skin clinic",
      "skin clinic gwanggyo",
      "gwanggyo dermatology clinic",
      "korean beauty clinic gwanggyo",
      "gwanggyo laser clinic",
      "gwanggyo laser hair removal",
      "gwanggyo acne treatment",
      "gwanggyo lifting treatment",
      "gwanggyo botox",
      "gwanggyo filler",
      "gwanggyo skin booster",
      "korean traditional medicine clinic gwanggyo",
    ],
    ja: [
      "光教 皮膚科",
      "光教 美容クリニック",
      "韓国 光教 皮膚クリニック",
      "光教 レーザー治療",
      "光教 シミ取り",
      "光教 リフティング",
      "光教 ボトックス",
      "光教 フィラー",
      "光教 脱毛 クリニック",
      "光教 韓国美容",
    ],
    zh: [
      "光教 皮肤科",
      "韩国光教 皮肤管理",
      "光教 医美 诊所",
      "光教 激光祛斑",
      "光教 脱毛",
      "光教 提拉",
      "光教 除皱针",
      "光教 痘痘治疗",
      "光教 韩医院 皮肤",
      "韩国光教 美容诊所 推荐",
    ],
  },
    },
    remoteReserve: {
      descArea: { ko: "광교", en: "Gwanggyo", ja: "光教", zh: "光教" },
      kw: {
  ko: [
    "비대면 진료",
    "원격 진료",
    "온라인 진료",
    "광교 비대면 진료",
    "광교 비대면 진료",
    "광교 한의원 비대면 진료",
    "원격진료 예약",
    "텔레메디슨",
    "끗 한의원 광교",
    "KKEUT Clinic",
  ],
  en: [
    "telemedicine",
    "remote care",
    "online clinic",
    "Gwanggyo telemedicine",
    "Gwanggyo telemedicine",
    "reservation",
    "KKEUT Clinic",
  ],
  ja: [
    "オンライン診療",
    "遠隔診療",
    "光教 オンライン診療",
    "光教 オンライン診療",
    "予約",
    "KKEUT 韓医院",
  ],
  zh: [
    "线上就诊",
    "远程医疗",
    "光教 线上诊疗",
    "光教 线上诊疗",
    "预约",
    "KKEUT 韩医院",
  ],
},
  google: "", // 미정 TODO — 사이트 소유확인 코드
  robots: { index: false, follow: false },
    },
    skinNote: {
  baseDesc: {
    ko: "광교 끗 한의원의 시술 노트를 한눈에. 시술 원리, 전후 관리, 케이스 인사이트를 정리했습니다.",
    en: "Browse KKEUT Clinic Gwanggyo's procedure notes — principles, aftercare tips, and case insights in one place.",
    ja: "光教のKKEUT韓医院の施術ノートです。施術原理、アフターケア、症例のポイントをまとめました。",
    zh: "集中查看光教 KKEUT韩医院的项目笔记：原理、术后护理与案例要点，一站式掌握。",
  },
  keywords: {
    ko: [
      "광교 끗 한의원",
      "광교 시술 노트",
      "광교 피부 시술",
      "레이저",
      "리프팅",
      "토닝",
      "제모",
      "여드름",
      "흉터",
      "색소",
    ],
    en: [
      "Gwanggyo procedure notes",
      "Gwanggyo dermatology",
      "laser",
      "lifting",
      "toning",
      "hair removal",
      "acne",
      "scar",
      "pigmentation",
    ],
    ja: [
      "光教 施術ノート",
      "光教 皮膚",
      "レーザー",
      "リフティング",
      "トーニング",
      "脱毛",
      "ニキビ",
      "瘢痕",
      "色素",
    ],
    zh: [
      "光教 项目笔记",
      "光教 皮肤",
      "激光",
      "提升",
      "嫩肤",
      "脱毛",
      "痤疮",
      "疤痕",
      "色素",
    ],
  },
  siteName: {
    ko: "끗 한의원 광교",
    en: "KKEUT Clinic Gwanggyo",
    ja: "KKEUT韓医院 光教",
    zh: "KKEUT韩医院 光教",
  },
    },
    network: {
  fallbackDomain: "https://www.kkeutclinic-gwanggyo.co.kr"
,
  naver: "", // 미정 TODO — 사이트 소유확인 코드
  google: "", // 미정 TODO — 사이트 소유확인 코드
    },
    clinicPrice: {
      supported: ["ko", "en", "ja", "zh"],
      jsonLdName: { ko: "광교 시술 목록", en: "Clinic Treatments - Gwanggyo" },
  baseDesc: {
    ko: "광교 끗 한의원의 시술/이벤트 안내입니다. 레이저·리프팅·제모·여드름·흉터 등 시술별 상세 정보를 확인하세요.",
    en: "Treatments and event information for KKEUT Clinic in Gwanggyo. Find details for laser, lifting, hair removal, acne and scar care.",
    ja: "光教 KKEUT韓医院の施術/イベント案内です。レーザー、リフティング、脱毛、ニキビ・瘢痕治療の詳細をご覧ください。",
    zh: "光教 KKEUT韩医院的项目和活动信息。查看激光、提升、脱毛、痘痘与疤痕治疗的详细说明。",
  },
  keywords: {
    ko: [
      "광교 시술",
      "광교 레이저토닝",
      "광교 제모",
      "광교 리프팅",
      "광교 여드름",
      "광교 피부과 시술",
      "광교 피부과",
      "광교 피부과 이벤트",
    ],
    en: [
      "Gwanggyo laser",
      "Gwanggyo lifting",
      "Gwanggyo treatment",
      "Gwanggyo skincare",
      "Gwanggyo dermatology event",
      "hair removal Gwanggyo",
    ],
    ja: [
      "光教 レーザー",
      "光教 リフティング",
      "光教 施術",
      "光教 レーザー",
      "光教 皮膚科 イベント",
    ],
    zh: [
      "光教 激光",
      "光教 提升",
      "光教 项目",
      "光教 激光",
      "光教 皮肤科 活动",
    ],
  },
  siteName: {
    ko: "끗 한의원",
    en: "KKEUT Clinic",
    ja: "KKEUT Clinic",
    zh: "KKEUT Clinic",
  },
  naver: "", // 미정 TODO — 사이트 소유확인 코드
  google: "", // 미정 TODO — 사이트 소유확인 코드
    },
  },


  // config/branch.js 에 있던 지점 정보 (#851).

  // 본인인증 수단 — 지점 단일 출처 (#835).
  // 예약·예약확인·비대면예약·전후사진·마이페이지가 모두 이 값 하나를 쓴다.
  // 화면마다 따로 두었더니 같은 지점 안에서도, 언어별로도 값이 갈렸다.
  ivChannels: [], // 미정 TODO — 카카오 심사 완료 전 인증 수단 숨김
  branchName: {"ko":"광교점","en":"Gwanggyo","ja":"光教店","zh":"光教店"},
  domain: "www.kkeutclinic-gwanggyo.co.kr",
  phone: "", // 미정 TODO
  address: "", // 미정 TODO
  businessNumber: "", // 미정 TODO
  naverLink: "", // 미정 TODO
  kakaoLink: "", // 미정 TODO
  // location / businessHours / social / menu 등은
  // 후속 컴포넌트 추출 시점에 채워 넣음 (Footer, Location 등 작업 단계).
  locales: ["ko", "en", "ja", "zh", "th"],
  defaultLocale: "ko",
  // 요양기관번호·호스트는 서버 전용이라 config 에 두지 않는다
  // (api/reservation/create 라우트가 env 로 주입). 아래는 화면이 쓰는 값이다.
  vegas: null, // 미정 TODO — 베가스 조직번호 미정, 전송 금지
  reserve: {
    enableIdentity: false, // 미정 TODO — 심사 전 수기 예약
    smsAgreeKo: "광교 끗 한의원에서 발송하는 시술안내, 공지 등 문자 수신에 동의합니다. (선택)",
  },
  remotePay: { enabled: false }, // 미정 TODO — 결제선생 회원/가맹점 ID
  // 미정 TODO — bssm 원본의 Facebook Pixel ID 미설정 상태 유지
  // 비대면예약 화면 (#835)
  remote: {
    enableIdentity: false, // 미정 TODO — 카카오 심사 전 수기 입력
    manualReservation: true, // 미정 TODO — 결제 없이 예약 접수만 진행
  },

};
